var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32.0001C24.8366 32.0001 32 24.8366 32 16.0001C32 7.16351 24.8366 6.10352e-05 16 6.10352e-05C7.16344 6.10352e-05 0 7.16351 0 16.0001C0 24.8366 7.16344 32.0001 16 32.0001ZM24.2092 7.82228H21.4222L16.8284 13.0481L12.8615 7.82357H7.11111L13.9791 16.7658L7.46808 24.1778H10.2576L15.2811 18.4609L19.6763 24.1778H25.284L18.1213 14.7497L24.2092 7.82228ZM21.9869 22.5175H20.4422L10.3615 9.39622H12.0178L21.9869 22.5175Z",
    fill: "#40484C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXDark);
export default __webpack_public_path__ + "static/media/x-dark.dafd6a5022e87e4d3f2a30732bdc9a54.svg";
export { ForwardRef as ReactComponent };